import {
  ActivitySectionLayout,
  StandardAreaInstallationTable
} from 'modules';


export type StandardAreaInstallationsDetailSectionProps = {};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const FC = (props: StandardAreaInstallationsDetailSectionProps) => {

  return (
    <ActivitySectionLayout.FC>
      <StandardAreaInstallationTable.FC />
    </ActivitySectionLayout.FC>

  );
};
